import ClinicVacancies from '@/src/jobPortal/allVacancies/containers/ClinicVacancies';
import JobPortalActivePage from '@/src/jobPortal/common/containers/JobPortalActivePage';
import {SectionContainer} from '@/src/ui';

interface AllVacanciesLayoutProps {
  withCommonSearchNavigation: boolean;
}

const AllVacanciesLayout = ({
  withCommonSearchNavigation,
}: AllVacanciesLayoutProps) => {
  if (withCommonSearchNavigation) {
    return (
      <ClinicVacancies
        isAllVacanciesPage={true}
        withCommonSearchNavigation={withCommonSearchNavigation}
      />
    );
  }

  return (
    <JobPortalActivePage>
      <SectionContainer>
        <ClinicVacancies
          isAllVacanciesPage={true}
          withCommonSearchNavigation={withCommonSearchNavigation}
        />
      </SectionContainer>
    </JobPortalActivePage>
  );
};

export default AllVacanciesLayout;
